import { useRecoilCallback } from "recoil";

import auth from "recoil/account/auth";
import bankDetailsAtom from "recoil/account/bankDetails";
import billingInfoAtom from "recoil/account/billingInfo";
import dateJoined from "recoil/account/dateJoined";
import paymentInfoAtom from "recoil/account/paymentInfo";
import phoneDetailsAtom from "recoil/account/phoneDetails";
import profilesAtom from "recoil/account/profiles";
import promoteChannelsAtom from "recoil/account/promoteChannels";
import regStepAtom from "recoil/account/regStep";
import rhpLinkAccountAtom from "recoil/account/rhpLinkAccount";
import campaignDateRangeIDAtom from "recoil/stats/campaignDateRangeID";
import { dashboardCampaignSelectionAtom, dashboardSelectedMonthAtom } from "recoil/stats/dashboardFilters";
import ticketDetailsAtom from "recoil/support/ticketDetail";
import ticketListAtom from "recoil/support/tickets";
import ticketListCriteriaAtom from "recoil/support/ticketsCriteria";

const useClearAllAtoms = () => {
  return useRecoilCallback(({ reset }) => () => {
    const allAtoms = [
        auth, bankDetailsAtom, billingInfoAtom, dateJoined, paymentInfoAtom,
        phoneDetailsAtom, profilesAtom, promoteChannelsAtom, regStepAtom,
        campaignDateRangeIDAtom,
        dashboardCampaignSelectionAtom, dashboardSelectedMonthAtom,
        ticketDetailsAtom, ticketListAtom, ticketListCriteriaAtom, rhpLinkAccountAtom
    ];
    allAtoms.forEach(reset);
  }, []);
};

export default useClearAllAtoms;
